import { render } from "./BookmarkModal.vue?vue&type=template&id=e5da857a&scoped=true"
import script from "./BookmarkModal.vue?vue&type=script&lang=js"
export * from "./BookmarkModal.vue?vue&type=script&lang=js"

import "./BookmarkModal.vue?vue&type=style&index=0&id=e5da857a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5da857a"]])

export default __exports__